// Shared page watermark overlay used by the Rx, referral and medical certificate.
// Follows the doctor's own watermark when they've set one (so it prints the same
// at every affiliated hospital); otherwise it falls back to the hospital's
// print settings. Render it as the first child of a position:relative page, and
// keep the page content above it (position:relative; z-index:1).
export default function RxWatermark({ doctor = {}, settings = {} }) {
  const wm = doctor.use_own_watermark
    ? {
        show_watermark: doctor.show_watermark,
        watermark_type: doctor.watermark_type,
        watermark_text: doctor.watermark_text,
        watermark_image_url: doctor.watermark_image_url,
        watermark_opacity: doctor.watermark_opacity,
        watermark_image_size: doctor.watermark_image_size,
        watermark_rotation: doctor.watermark_rotation,
        watermark_font_size: doctor.watermark_font_size,
      }
    : settings;

  if (wm.show_watermark === false) return null;

  return (
    <div
      className="absolute pointer-events-none select-none overflow-hidden"
      style={{ zIndex: 0, left: 0, top: 0, width: "100%", height: "100%" }}
      data-testid="doc-watermark"
      aria-hidden="true"
    >
      {wm.watermark_type === "image" && wm.watermark_image_url ? (
        <img
          src={wm.watermark_image_url}
          alt=""
          aria-hidden="true"
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            width: `${Number(wm.watermark_image_size ?? 55)}%`,
            maxWidth: "90%",
            height: "auto",
            opacity: Number(wm.watermark_opacity ?? 0.1),
            transform: "translate(-50%, -50%)",
            objectFit: "contain",
            transformOrigin: "center center",
          }}
        />
      ) : (
        Array.from({ length: 30 }).map((_, i) => {
          const col = i % 5;
          const row = Math.floor(i / 5);
          return (
            <div
              key={i}
              style={{
                position: "absolute",
                left: `${col * 22 + 2}%`,
                top: `${row * 16 + 3}%`,
                opacity: Number(wm.watermark_opacity ?? 0.1),
                transform: `rotate(${Number(wm.watermark_rotation ?? -35)}deg)`,
                fontSize: `${Number(wm.watermark_font_size ?? 28)}pt`,
                fontWeight: 700,
                color: "#334155",
                whiteSpace: "nowrap",
                fontFamily: "Work Sans, Arial, sans-serif",
              }}
            >
              {String(wm.watermark_text || "Rx")}
            </div>
          );
        })
      )}
    </div>
  );
}
